import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_protected/workflows/')({
  component: lazyRouteComponent(() => import('@/pages/workflows/page'), 'Workflows'),
  validateSearch: (search: Record<string, unknown>) => {
    const type = search.type
    const tab = search.tab
    return {
      type: typeof type === 'string' && type.trim() ? type.trim() : undefined,
      tab:
        tab === 'workflows' || tab === 'runs' || tab === 'schedules'
          ? tab
          : undefined,
    }
  },
})

